/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Phase_Note_AdaptationInputs */

const en_us2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first weeks have fewer sets on purpose, while your body and the habit settle in. The volume goes up after that.`)
};

const pt_br2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As primeiras semanas têm menos séries, de propósito, enquanto o corpo e o hábito se ajustam. O volume sobe em seguida.`)
};

const es_419_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las primeras semanas tienen menos series a propósito, mientras tu cuerpo y el hábito se adaptan. Después el volumen sube.`)
};

const pt_pt2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As primeiras semanas têm menos séries, de propósito, enquanto o corpo e o hábito se ajustam. Depois o volume sobe.`)
};

const fr_fr2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les premières semaines ont moins de séries, exprès, le temps que ton corps et l'habitude s'installent. Le volume augmente ensuite.`)
};

const de_de2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ersten Wochen haben absichtlich weniger Sätze, während sich dein Körper und die Gewohnheit einspielen. Danach steigt das Volumen.`)
};

const it_it2_plan_phase_note_adaptation = /** @type {(inputs: Plan_Phase_Note_AdaptationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le prime settimane hanno meno serie apposta, mentre il corpo e l'abitudine si assestano. Poi il volume sale.`)
};

/**
* | output |
* | --- |
* | "The first weeks have fewer sets on purpose, while your body and the habit settle in. The volume goes up after that." |
*
* @param {Plan_Phase_Note_AdaptationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_phase_note_adaptation = /** @type {((inputs?: Plan_Phase_Note_AdaptationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Phase_Note_AdaptationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_phase_note_adaptation(inputs)
	if (locale === "es-419") return es_419_plan_phase_note_adaptation(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_phase_note_adaptation(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_phase_note_adaptation(inputs)
	if (locale === "de-DE") return de_de2_plan_phase_note_adaptation(inputs)
	if (locale === "it-IT") return it_it2_plan_phase_note_adaptation(inputs)
	return en_us2_plan_phase_note_adaptation(inputs)
});
export { plan_phase_note_adaptation as "plan.phase_note.adaptation" }